import { FC, Suspense } from 'react';
import { ExperienceRelatedPostWithClickableDetail } from './related-post-with-clickable-detail';
import { ArticleRecommendSkeleton } from '~/skeleton/article';
import { ExperienceMainSections } from './experience-main-section';
import { NoSSR } from '~/utils/no-ssr';
import { AIOverviewInfoModal } from '../shared/component';
import { useAtomValue } from 'jotai';
import { $CurrentAvailableExperienceDataOrNull } from '../shared/atoms';
import { NotFound } from '~/components/not-found';
import { ExperienceSilentAwaken } from './experience-silent-awaken';

export const ExperienceBody: FC = () => {
  const experienceData = useAtomValue($CurrentAvailableExperienceDataOrNull);
  if (!experienceData) {
    return <NotFound />;
  }
  return (
    <>
      <ExperienceSilentAwaken />
      <ExperienceMainSections />
      <NoSSR>
        <AIOverviewInfoModal />
      </NoSSR>
      <Suspense fallback={<ArticleRecommendSkeleton />}>
        <ExperienceRelatedPostWithClickableDetail />
      </Suspense>
    </>
  );
};
